namespace $ {

	type $shm_hitalama_map_templates_snippet_meta = {
		link: string
		title: string
		file: string
		sql_file?: string
		entity_link?: string
		x: number
		y: number
		width: number
		height: number
		type?: $shm_hitalama_map_widget_def_type_name
	}

	type $shm_hitalama_map_templates_kind = 'js' | 'tsx' | 'sql'

	type $shm_hitalama_map_templates_config = {
		kind: $shm_hitalama_map_templates_kind
		title: string
		root_link: string
		default_type: $shm_hitalama_map_widget_def_type_name
		changed_at: number
	}

	type $shm_hitalama_map_templates_inline = {
		title: string
		code: string
		width?: number
		height?: number
		autorun?: boolean
	}

	export class $shm_hitalama_map_templates extends $mol_object {

		static overlayed_version() {
			return 3
		}

		static overlayed_version_key() {
			return 'overlayed_template_version'
		}

		static overlayed_dto_cache = null as null | $shm_hitalama_transfer_dump
		static overlayed_dto_promise = null as null | Promise< $shm_hitalama_transfer_dump >

		static overlayed_dto_async() {
			if( this.overlayed_dto_cache ) return Promise.resolve( this.overlayed_dto_cache )
			if( this.overlayed_dto_promise ) return this.overlayed_dto_promise

			const base = '/shm/hitalama/map/templates/snippets/overlayed/'
			const uri = $shm_hitalama_ghpages_fix_link( base + 'overlayed_map.json' )
			return this.overlayed_dto_promise = fetch( uri )
				.then( response => {
					if( response.ok ) return response.text()
					throw new Error( response.statusText || `HTTP ${ response.status }` )
				} )
				.then( text => this.overlayed_dto_cache = JSON.parse( text ) as $shm_hitalama_transfer_dump )
				.catch( error => {
					this.overlayed_dto_promise = null
					throw error
				} )
		}

		static commands_version() {
			return 7
		}

		static commands_version_key() {
			return 'commands_template_version'
		}

		static make_map(
			title: string,
			widget_type: $shm_hitalama_map_widget_def_type_name,
			templates: readonly $shm_hitalama_map_templates_inline[],
		) {
			const map = $shm_hitalama_map.make_new( title, 'private' )
			let y = 40

			templates.forEach( template => {
				const width = template.width ?? 420
				const height = template.height ?? 110
				const widget = map.widget_add( widget_type, [ 40, y ], width, height )
				widget?.title( template.title )
				widget?.code( template.code )
				widget?.enabled( template.autorun ?? true )
				y += height + 30
			} )

			return map
		}

		static command_templates(): readonly $shm_hitalama_map_templates_inline[] {
			return [
				{
					title: 'Создать: Приватная карта',
					code: `$shm_hitalama_app.Root(0).add_map( 'private' )`,
					width: 600,
					height: 250,
					autorun: false,
				},
				{
					title: 'Создать: Публичная карта',
					code: `$shm_hitalama_app.Root(0).add_map( 'public_read' )`,
					width: 600,
					height: 250,
					autorun: false,
				},
				{
					title: 'Создать: Публичная редактируемая карта',
					code: `$shm_hitalama_app.Root(0).add_map( 'public_edit' )`,
					width: 600,
					height: 250,
					autorun: false,
				},
				{
					title: 'Виджет: Дашборды',
					code: `
{
const map = $shm_hitalama_app.Root(0).map()
const center = $shm_hitalama_app.Root(0).Map().Map_page().get_center_pos() ?? [ 0, 0 ]
const gap = 10
const auth_width = 300
const auth_height = 500
const book_width = 1500
const book_height = 900
const left = center[0] - ( auth_width + gap + book_width ) / 2
const top = center[1] - Math.max( auth_height, book_height ) / 2
const scoped_pb_code = [
	'function auth_state( next ) {',
	'	const prev = auth_view.data() || {}',
	'	if( next === undefined ) return prev',
	'	let changed = false',
	'	for( const key in next ) {',
	'		if( prev[ key ] !== next[ key ] ) changed = true',
	'	}',
	'	if( !changed ) return prev',
	'	auth_view.data({ ... prev, ... next })',
	'	return auth_view.data() || {}',
	'}',
	'function make_scoped_view( View, config ) {',
	'	const obj = new View',
	'	obj.$ = scoped',
	'	for( const name in config || {} ) {',
	'		const value = config[ name ]',
	'		obj[ name ] = typeof value === "function" ? value : function() { return value }',
	'	}',
	'	return obj',
	'}',
	'const ScopedPb = class extends $.$shm_ba_pb {',
	'	static _realtime = { source: null, client_id: "", topics: new Set }',
	'	static _realtime_global = new Set',
	'	static _realtime_filtered = new Set',
	'	static _realtime_live = new Set',
	'	static _realtime_cache_pending = new WeakSet',
	'	static default_url() { return $.$shm_ba_pb.default_url() }',
	'	static url() { return String( auth_state().pb_url || this.default_url() ).replace( new RegExp( "/+$" ), "" ) }',
	'	static admin_auth_state( key ) { return String( auth_state()[ key ] || "" ) }',
	'	static auth_state( key ) { return "" }',
	'	static auth_reset() {',
	'		auth_state({ token: "", user_id: "", email: "" })',
	'		this.realtime_reset()',
	'	}',
	'	static user_auth_reset() {}',
	'	static admin_auth_valid( token ) {',
	'		if( !token ) return false',
	'		const result = $mol_error_fence(',
	'			()=> {',
	'				const response = $mol_fetch.response( this.url() + "/api/collections/_superusers/auth-refresh", {',
	'					method: "POST",',
	'					headers: this.admin_headers(),',
	'				} )',
	'				const data = response.json()',
	'				if( !response.ok() ) {',
	'					if( this.response_auth_failed( response ) ) this.auth_reset()',
	'					return false',
	'				}',
	'				if( data.token ) auth_state({ token: data.token })',
	'				if( data.record?.id ) auth_state({ user_id: data.record.id })',
	'				if( data.record?.email ) auth_state({ email: data.record.email })',
	'				return true',
	'			},',
	'			()=> false,',
	'			promise => { throw promise },',
	'		)',
	'		return Boolean( result )',
	'	}',
	'}',
	'$.$mol_mem_key( ScopedPb, "admin_auth_valid" )',
	'const scoped = $.$mol_ambient({ $shm_pb: ScopedPb, $shm_ba_pb: ScopedPb })',
].join( '\\n' )

const auth_view = map.widget_add( 'autoview', [ left, top ], auth_width, auth_height )
auth_view?.title( 'Superuser' )
const auth_code = map.widget_add( 'code_js', [ left, top ], auth_width, auth_height )
auth_code?.title( 'Code: Superuser' )
auth_code?.code( [
	'{',
	'const auth_view = ' + '$' + 'this_widget.view_widget()',
	'if( !auth_view ) throw new Error( "No auth view widget" )',
	scoped_pb_code,
	'const view = make_scoped_view( scoped.$shm_dashboard_admin_auth, {',
	'	state: ( key, next )=> {',
	'		if( next !== undefined ) {',
	'			auth_state({ [ key ]: next })',
	'			return next || ""',
	'		}',
	'		return String( auth_state()[ key ] || "" )',
	'	},',
	'	pb_url_override: ( next )=> {',
	'		if( next !== undefined ) {',
	'			auth_state({ pb_url: next })',
	'			return next || ""',
	'		}',
	'		return String( auth_state().pb_url || "" )',
	'	},',
	'	message: ' + '$' + 'view_data( "message", "" ),',
	'} )',
	'return view',
	'}',
].join( '\\n' ) )
auth_code?.enabled( true )
auth_code?.view_widget( auth_view )
auth_view?.code_widget( auth_code )
if( auth_code ) map.widget_cut( auth_code.link() )

const book_left = left + auth_width + gap
const book_view = map.widget_add( 'autoview', [ book_left, top ], book_width, book_height )
book_view?.title( 'Дашборды' )
const book_code = map.widget_add( 'code_js', [ book_left, top ], book_width, book_height )
book_code?.title( 'Code: Дашборды' )
book_code?.code( [
	'{',
	'const auth_view = ' + '$' + 'widget( ' + JSON.stringify( auth_view?.link_str() ?? '' ) + ' )',
	'if( !auth_view ) throw new Error( "No auth view widget" )',
	scoped_pb_code,
	'return make_scoped_view( scoped.$shm_dashboard_admin_book )',
	'}',
].join( '\\n' ) )
book_code?.enabled( true )
book_code?.view_widget( book_view )
book_view?.code_widget( book_code )
if( book_code ) map.widget_cut( book_code.link() )

return [ auth_view, book_view ]
}
`.trim(),
					width: 600,
					height: 520,
					autorun: false,
				},
			]
		}

		static commands_update( map: $shm_hitalama_map ) {
			const widgets = map.Widgets_list(null)?.remote_list() ?? []
			let y = 40

			for( const template of this.command_templates() ) {
				const width = template.width ?? 420
				const height = template.height ?? 110
				const widget = widgets.find( ( widget: $shm_hitalama_map_widget )=> widget.code() === template.code || widget.title() === template.title )
					?? map.widget_add( 'code_js', [ 40, y ], width, height, template.title )

				if( !widget ) continue

				const enabled = template.autorun ?? true
				if( widget.title() !== template.title ) widget.title( template.title )
				if( widget.code() !== template.code ) widget.code( template.code )
				if( widget.right_edge_x() !== width ) widget.right_edge_x( width )
				if( widget.bottom_edge_y() !== height ) widget.bottom_edge_y( height )
				if( widget.enabled() !== enabled ) widget.enabled( enabled )
				y += height + 30
			}
			if( Number( map.store( this.commands_version_key() ) ?? 0 ) !== this.commands_version() ) {
				map.store( this.commands_version_key(), this.commands_version() )
			}
			return map
		}

		static import_js() {
			return this.import({
				kind: 'js',
				title: 'JS шаблоны',
				root_link: 'templates_js',
				default_type: 'code_js',
				changed_at: 1782777600000,
			})
		}

		static import_tsx() {
			return this.import({
				kind: 'tsx',
				title: 'TSX шаблоны',
				root_link: 'templates_tsx',
				default_type: 'code_ts',
				changed_at: 1777410482805,
			})
		}

		static import_sql() {
			return this.import({
				kind: 'sql',
				title: 'SQL шаблоны',
				root_link: 'templates_sql',
				default_type: 'code_sql',
				changed_at: 1777587844506,
			})
		}

		static import_commands() {
			const map = this.make_map(
				'Команды',
				'code_js',
				this.command_templates(),
			)
			map.store( this.commands_version_key(), this.commands_version() )
			return map
		}

		static commands_actual( map: $shm_hitalama_map ) {
			const version = Number( map.store( this.commands_version_key() ) ?? 0 )
			if( version >= this.commands_version() ) return this.commands_update( map )

			return this.commands_update( map )
		}

		static import_overlayed() {
			const map = $shm_hitalama_map.make_new( 'Overlay-карта', 'private' )
			return this.overlayed_apply( map )
		}

		static overlayed_update( map: $shm_hitalama_map ) {
			const version = Number( map.store( this.overlayed_version_key() ) ?? 0 )
			if( version >= this.overlayed_version() && this.overlayed_filled( map ) ) return map

			return this.overlayed_apply( map )
		}

		static overlayed_filled( map: $shm_hitalama_map ) {
			const first = map.Widgets_list(null)?.remote_list()[0]
			if( !first ) return false
			return first.right_edge_x() > 0 && first.bottom_edge_y() > 0
		}

		static overlayed_apply( map: $shm_hitalama_map ) {
			$shm_hitalama_transfer_map.make({
				map: ()=> map,
			}).deserialize_map( this.overlayed_dto() )
			map.store( this.overlayed_version_key(), this.overlayed_version() )
			map.Widgets_list(null)?.remote_list([ ...map.Widgets_list(null)!.remote_list() ])
			map.Widgets_removed_list(null)?.remote_list([ ...map.Widgets_removed_list(null)!.remote_list() ])
			return map
		}

		@ $mol_mem
		static overlayed_dto() {
			return $mol_wire_sync( this ).overlayed_dto_async()
		}

		static import( config: $shm_hitalama_map_templates_config ) {
			const map = $shm_hitalama_map.make_new( config.title, 'private' )
			const dto = this.dto( config )
			map.deserialize( dto )
			const widgets = map.Widgets_list(null)
			if( widgets ) widgets.remote_list([ ...widgets.remote_list() ])
			const removed = map.Widgets_removed_list(null)
			if( removed ) removed.remote_list([ ...removed.remote_list() ])
			return map
		}

		static dto( config: $shm_hitalama_map_templates_config ): $shm_hitalama_transfer_dump {
			const base = `/shm/hitalama/map/templates/snippets/${ config.kind }/`
			const index_json = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( base + '_index.json' ) )
			const templates = JSON.parse( index_json ) as $shm_hitalama_map_templates_snippet_meta[]
			const time = 1777410482805
			const widgets_link = config.root_link + '_widgets'
			const widgets_removed_link = config.root_link + '_widgets_removed'

			return {
				format: 'hitalama_transfer',
				root_link: config.root_link,
				nodes: [
					{
						link: config.root_link,
						title: config.title,
						class_name: '$shm_hitalama_map',
						fields: {
							Title: { kind: 'atom', value: config.title },
							Widgets: {
								kind: 'link',
								link: widgets_link,
								class_name: '$giper_baza_list_link.to',
							},
							Widgets_removed: {
								kind: 'link',
								link: widgets_removed_link,
								class_name: '$giper_baza_list_link.to',
							},
							Created_at: { kind: 'atom', value: time },
							Changed_at: { kind: 'atom', value: config.changed_at },
							Access_level: { kind: 'atom', value: 'private' },
							Version: { kind: 'atom', value: 1 },
						},
					},
					{
						link: widgets_link,
						class_name: '$giper_baza_list_link.to',
						fields: {},
						items: templates.map( template => ({
							kind: 'link',
							link: template.link,
							class_name: '$shm_hitalama_map_widget',
						}) ),
					},
					... templates.flatMap( template => this.widget_nodes( base, config, template, time ) ),
					{
						link: widgets_removed_link,
						class_name: '$giper_baza_list_link.to',
						fields: {},
						items: [],
					},
				],
			}
		}

		static widget_nodes(
			base: string,
			config: $shm_hitalama_map_templates_config,
			template: $shm_hitalama_map_templates_snippet_meta,
			time: number,
		): $shm_hitalama_transfer_node[] {
			const code = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( base + template.file ) )
			const render_data = {
				title: template.title,
				type: template.type ?? config.default_type,
				text: code,
				value_refs: $shm_hitalama_map_widget_value_refs( code ),
				body_x: template.x,
				body_y: template.y,
				right_edge_x: template.width,
				bottom_edge_y: template.height,
				opacity: 1,
			}
			const fields: Record< string, $shm_hitalama_transfer_field > = {
				Render_data: { kind: 'atom', value: render_data },
				Created_at: { kind: 'atom', value: time },
				Map: {
					kind: 'link',
					link: config.root_link,
					class_name: '$shm_hitalama_map',
				},
				Text_crdt_disabled: { kind: 'atom', value: true },
				Text_atom: { kind: 'atom', value: code },
			}

			const nodes: $shm_hitalama_transfer_node[] = []
			if( template.sql_file ) {
				const entity_link = template.entity_link ?? template.link + '_entity'
				fields.Code_sql = {
					kind: 'link',
					link: entity_link,
					class_name: '$shm_hitalama_map_widget_entity_code_sql',
				}
				nodes.push({
					link: entity_link,
					class_name: '$shm_hitalama_map_widget_entity_code_sql',
					fields: {
						Sql: {
							kind: 'text',
							value: this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( base + template.sql_file ) ),
						},
					},
				})
			}

			return [{
				link: template.link,
				title: template.title,
				class_name: '$shm_hitalama_map_widget',
				fields,
			}, ... nodes]
		}

	}

}
